import { AUDIO_CONFIG } from "../config/audio.ts";
import type {
  AudioEnvironmentContext,
  AudioSurfaceKind,
} from "./types.ts";

const ROAD_PREFIXES = [
  "road:",
  "path:",
  "asphalt:",
  "street:",
  "sidewalk:",
];
const BUILDING_PREFIXES = [
  "building:",
  "interior:",
  "wood:",
  "floor:",
];

/**
 * Resolves project-owned semantic surface IDs without binding audio to physics
 * handles. Exact app-provided metadata wins; known stable prefixes are the
 * fallback, and unknown/null ground is treated as terrain.
 */
export function classifyAudioSurface(
  surfaceId: string | null,
  environment: Readonly<AudioEnvironmentContext>,
): AudioSurfaceKind {
  if (surfaceId !== null) {
    const override = environment.surfaceOverridesById?.[surfaceId];
    if (override !== undefined) {
      return override;
    }
    if (ROAD_PREFIXES.some((prefix) => surfaceId.startsWith(prefix))) {
      return "road";
    }
    if (BUILDING_PREFIXES.some((prefix) => surfaceId.startsWith(prefix))) {
      return "building-ground";
    }
  }
  return "terrain";
}

export interface SurfaceVoiceProfile {
  highpassHertz: number;
  lowpassHertz: number;
  playbackRate: number;
  gainScale: number;
  noiseMemory: number;
}

export function surfaceVoiceProfile(
  surface: AudioSurfaceKind,
): Readonly<SurfaceVoiceProfile> {
  switch (surface) {
    case "road":
      return AUDIO_CONFIG.surfaceProfiles.road;
    case "building-ground":
      return AUDIO_CONFIG.surfaceProfiles.buildingGround;
    case "terrain":
      return AUDIO_CONFIG.surfaceProfiles.terrain;
  }
}
